// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2CzkB","info":"PatientInfo_info__1DhaD"};